import {ReactComponent as Svg1500} from "../../assets/weAreSpeakingLouderSection/1500+.svg"
import {ReactComponent as Svg25} from "../../assets/weAreSpeakingLouderSection/25.svg"
import { ReactComponent as Svg15 } from "../../assets/weAreSpeakingLouderSection/15.svg";

const impactData = [
  {
    id: 1,
    svg: <Svg1500/>,
    text: "Attendees",
  },
  {
    id: 2,
    svg: <Svg25/>,
    text: "Speakers",
  },
  {
    id: 3,
    svg: <Svg15/>,
    text: "Sessions",
  },
];

export default impactData 
